<template>
  <main class="main page-inside text-page" v-if="!loading">
    <div class="main-wrapper">
      <div class="section hero-section">
        <img src="./../img/hero.jpg" class="bg"/>
        <div class="wrapper home">
          <div class="title big" v-html="pageData.title"/>
        </div>
      </div>
      <section class="section store-section">
        <img src="./../img/section6.svg" class="bg"/>
        <transition name="fade">
          <div class="wrapper" v-if="pageData.title">
            <div class="content">
              <div class="desc" v-html="pageData.content"></div>
            </div>
          </div>
        </transition>
      </section>
      <div class="section store-section-2">
        <img src="./../img/section7.png" class="bg"/>
        <div class="wrapper">
          <div class="title small server-status"><span>S</span>ERVER <span>S</span>TATUS: <span class="green">ONLINE</span></div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'TextPage',
  props: ['slug', 'id'],
  components: {
  },
  data: function() {
    return {
      loading: true,
      pageData: {
        title: '',
        content: '',
        header: ''
      }
    }
  },
  async mounted() {
    // Handle both slug and id parameters
    const identifier = this.slug || this.$route.params.slug || this.$route.params.id;
    await this.loadPageContent(identifier);
  },
  watch: {
    '$route'(to) {
      // Re-fetch content when route changes
      const identifier = this.slug || to.params.slug || to.params.id;
      this.loading = true;
      this.loadPageContent(identifier);
    }
  },
  methods: {
    async loadPageContent(identifier) {
      try {
        const response = await this.$http.get(process.env.VUE_APP_API + 'static-pages/' + identifier);
        if (response.data && response.data.payload) {
          this.pageData = response.data.payload;
          this.loading = false;
        } else {
          this.redirectToNotFound();
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.redirectToNotFound();
        } else {
          console.error('Error loading page content:', error);
          this.redirectToNotFound();
        }
      }
    },
    redirectToNotFound() {
      this.$router.push({ name: 'PageNotFound' });
    }
  }
}
</script>